<template>
<vs-row
  v-if="pagedResources.page.totalPages>1"
  vs-type="flex"
  vs-justify="space-between"
  vs-w="12">
  <vs-col
    class="vs-pagination--mb"
    vs-type="flex"
    vs-justify="center"
    vs-align="center"
    vs-lg="12"
    vs-sm="12"
    vs-xs="12">
    <div
      :style="stylePagination"
      :class="[`vs-pagination-${color}`]"
      class="con-vs-pagination">
      <nav class="vs-pagination--nav">
        <button
          :class="{disabled: !pagedResources.$hasLink('first') ? 'disabled' : null}"
          :disabled="!pagedResources.$hasLink('first')"
          class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-first"
          @click="firstPage">
          <vs-icon
            :icon-pack="'material-icons'"
            :icon="'first_page'"
          ></vs-icon>
        </button>
        <button
          :class="{disabled: !pagedResources.$hasLink('prev') ? 'disabled' : null}"
          :disabled="!pagedResources.$hasLink('prev')"
          class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
          @click="prevPage">
          <vs-icon
            :icon-pack="'material-icons'"
            :icon="'chevron_left'"
          ></vs-icon>
        </button>
        <ul class="vs-pagination--ul">
          <li
            v-for="(page, index) in pages"
            :key="index"
            :class="{'is-current': page === pagedResources.page.number}"
            class="item-pagination vs-pagination--li"
            @click="goTo(page)">
              <span>
                {{ page + 1 }}
              </span>

            <div class="effect"></div>
          </li>
        </ul>
        <button
          :class="{disabled:!pagedResources.$hasLink('next') ? 'disabled' : null}"
          :disabled="!pagedResources.$hasLink('next')"
          class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
          @click="nextPage">
          <vs-icon
            :icon-pack="'material-icons'"
            :icon="'chevron_right'"
          ></vs-icon>
        </button>
        <button
          :class="{disabled:!pagedResources.$hasLink('last') ? 'disabled' : null}"
          :disabled="!pagedResources.$hasLink('last')"
          class="vs-pagination--buttons btn-next-pagination vs-pagination--button-last"
          @click="lastPage">
          <vs-icon
            :icon-pack="'material-icons'"
            :icon="'last_page'"
          ></vs-icon>
        </button>
      </nav>
    </div>
  </vs-col>
</vs-row>
</template>
<script>
import _color from '@/assets/utils/color.js';
import {ResourceImpl} from 'hal-client';

export default {
  name: 'sm-pagination',
  props: {
    pagedResources: {
      type: ResourceImpl,
      required: true
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  data () {
    return {
      current: this.pagedResources.page.number,
      pages: [],
      prevRange: '',
      nextRange: '',
      indexRows: 0
    };
  },
  computed: {
    stylePagination () {
      let style = {};
      if (!_color.isColor(this.color)) {
        style = {
          '--vs-color-pagination': _color.getColor(this.color),
          '--vs-color-pagination-alpha': _color.getColor(this.color, .5)
        };
      }
      return style;
    },
    styleDescription () {
      return {
        'cursor': 'pointer'
      };
    }
  },
  watch: {
    'pagedResources.page': {
      deep: true,
      handler (page) {
        this.getPages();
        this.current = page.number;
      }
    }
  },
  mounted () {
    this.current = this.pagedResources.page.number;
    this.getPages();
  },
  methods: {
    getPages () {
      let length = 10;
      const total = this.pagedResources.page.totalPages;
      const current = this.pagedResources.page.number;
      if (length > this.pagedResources.page.totalPages) {
        length = this.pagedResources.page.totalPages;
      }

      let start = current - Math.floor(length / 2);
      start = Math.max(start, 0);
      start = Math.min(start, total - length);
      const pages = Array.from({length}, (el, i) => start + i);
      this.pages = pages;
      return pages;
    },
    goTo (page) {
      this.current = page;
      this.$emit('change', this.current);
    },
    prevPage () {
      if (this.pagedResources.$hasLink('prev')) {
        this.current--;
        this.$emit('change', this.current);
      }
    },
    nextPage () {
      if (this.pagedResources.$hasLink('next')) {
        this.current++;
        this.$emit('change', this.current);
      }
    },
    firstPage () {
      if (this.pagedResources.$hasLink('first')) {
        this.current = 0;
        this.$emit('change', this.current);
      }
    },
    lastPage () {
      if (this.pagedResources.$hasLink('last')) {
        this.current = this.pagedResources.page.totalPages - 1;
        this.$emit('change', this.current);
      }
    }
  }
};
</script>
